import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { OnboardingDialogResult } from '@app/+authenticated/shared/onboarding/onboarding-dialog/onboarding-dialog.model';
import { OnboardingUtils } from '@app/+onboarding/onboarding.utils';
import { KnowledgeBaseArticleLinkModule } from '@app/pipes/knowledge-base-article-link.module';
import { TrackingService } from '@app/services/tracking.service';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonThemePalette } from '@sb/ui/button';
import { DIALOG_DATA, DialogActivationComponent, DialogRef } from '@sb/ui/dialog';

import { OnboardingChapterModule } from '../components/chapter.module';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'time-tracking-summary-dialog',
  imports: [DialogActivationComponent, TranslatePipe, NgStyle, OnboardingChapterModule, KnowledgeBaseArticleLinkModule],
  templateUrl: './time-tracking-summary-dialog.component.html',
})
export class TimeTrackingSummaryDialogComponent implements OnInit {
  private eventData = inject(DIALOG_DATA);
  private dialogRef = inject(DialogRef);
  private trackingService = inject(TrackingService);
  private onboardingUtils = inject(OnboardingUtils);

  ButtonThemePalette = ButtonThemePalette;

  get chapterCTAs() {
    return this.onboardingUtils.chapterCTAs();
  }

  ngOnInit() {
    this.trackingService.event('Onboarding Time Tracking Completed', this.eventData);
  }

  close(result: OnboardingDialogResult) {
    this.dialogRef.close(result);
  }
}
